import { render, staticRenderFns } from "./NewsCategoryDeleteDialog.vue?vue&type=template&id=7c280fe8&"
import script from "./NewsCategoryDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports